import http from '@/services/http';

const customers = {
  autocompleteFetch(
    key,
    value,
    exact = false,
    searchById = false,
    config = {}
  ) {
    const filter = {
      where: {
        or: [{ [key]: exact ? value : { regexp: `/${value}/i` } }],
      },
    };
    if (searchById && Number.isInteger(Number(value))) {
      filter.where.or.push({
        id: value,
      });
    }
    return http.request({
      method: 'get',
      url: '/customers',
      params: { filter },
      ...config,
    });
  },
  findCustomerByName(name, config = {}) {
    const filter = {
      where: {
        name,
        limit: 1,
      },
    };
    return http.request({
      method: 'get',
      url: '/customers',
      params: { filter },
      ...config,
    });
  },
  getCustomer(id, config = {}) {
    return http.request({
      method: 'get',
      url: `/customers/${id}`,
      ...config,
    });
  },
  getCustomerAddresses(id, config = {}) {
    return http.request({
      method: 'get',
      url: `/customers/${id}/addresses`,
      ...config,
    });
  },
  getCustomerAddress(id, config = {}) {
    return http.request({
      method: 'get',
      url: `/customers/addresses/${id}`,
      ...config,
    });
  },
  createAddress(id, data) {
    return http.request({
      method: 'post',
      url: `/customers/${id}/addresses`,
      data,
    });
  },
  updateAddressCountryFields(id, data) {
    return http.request({
      method: 'patch',
      url: `/addresses/${id}`,
      data,
    });
  },
  getFinalCustomers(id, config = {}) {
    return http.request({
      method: 'get',
      url: `/customers/${id}/final-customers`,
      ...config,
    });
  },
};

export default customers;
